import { Container, Stack } from '@mantine/core'
import classes from '../../styles/StudioEditorV2.module.css'

export function EditorShell({ header, editor, preview }) {
  return (
    <Container size="xl" py="lg" className={classes.page}>
      <Stack gap="lg">
        {header}
        <div className={classes.columns}>
          <main className={classes.formColumn}>{editor}</main>
          <aside className={classes.previewColumn}>{preview}</aside>
        </div>
      </Stack>
    </Container>
  )
}
